/* eslint-disable */
import React, { useState, useEffect } from "react";
import Select from "react-select";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { useTranslation } from "react-i18next";
import { getCustomStyles } from "Config/Config";

const AddCompanyModal = ({
  moduleName = "",
  selectedIds = [],
  afterModalClose = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
  onModalClose = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");

  const [companyInput, setCompanyInput] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);

  const [companyValue, setCompanyValue] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyName, setCompanyName] = useState("");

  const [isSaving, setIsSaving] = useState(false);

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  // validate =========================
  const validationHandler = () => {
    const newErrors = {};
    if (selectedCompany === null) {
      newErrors.companyWarning = t("Please select company");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get followers input
  const companyInputHandler = (val) => {
    setCompanyInput(val);
  };

  //function for get all company list
  const getCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}&modulefrom=backend`;

      console.log("url of company------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company------>", response);

      if (response.status) {
        setCompanyOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //select followers
  const companySelectionHandler = (val) => {
    if (val) {
      setCompanyValue(val);
      setSelectedCompany(val.value);
      setCompanyName(val.label);
    } else {
      setCompanyValue(null);
      setSelectedCompany(null);
      setCompanyName("");
    }
  };

  // 🔹 config: module → API mapping
  const moduleApiMap = {
    project: url.API_UPDATE_PROJECT,
    lead: url.API_UPDATE_LEAD,
    // future module add here
  };

  // module → payload builder
  const buildApiData = (moduleName, selectedCompany) => {
    switch (moduleName) {
      case "project":
        return { companyid: selectedCompany };
      case "lead":
        return { companyid: selectedCompany, company: companyName };
      // add case for other modules if needed
      default:
        return {}; // default empty payload
    }
  };

  //function for save company
  const addCompanyHandler = async (action) => {
    // 1️⃣ Validate before sending requests
    if (!validationHandler()) {
      setShowAlert(true);
      setAlertMessage("Please select company for company execution");
      setMessageType("error");
      return;
    }

    if (!selectedIds || selectedIds.length === 0) {
      setShowAlert(true);
      setAlertMessage("Please select data for follower execution");
      setMessageType("error");
      return;
    }

    // 2️⃣ Resolve API endpoint dynamically
    const apiEndpoint = moduleApiMap[moduleName];
    if (!apiEndpoint) {
      setShowAlert(true);
      setAlertMessage(`Unknown module "${moduleName}". Please refresh once.`);
      setMessageType("error");
      return;
    }

    const requestUrl = `${url.API_BASE_URL}${apiEndpoint}`;

    try {
      setIsSaving(true);

      // 3️⃣ Prepare all requests
      const requests = selectedIds.map((selectedId) => {
        const apiData = buildApiData(moduleName, selectedCompany);
        const companyUrl = `${requestUrl}/${selectedId}?token=${token}&action=${action}`;
        return putData(companyUrl, apiData);
      });

      // 4️⃣ Execute all requests in parallel
      const responses = await Promise.all(requests);

      // 5️⃣ Collect success + error
      const successData = [];
      let errorFound = false;

      responses.forEach((res) => {
        if (res.status) {
          successData.push(res.data);
        } else {
          errorFound = true;
        }
      });

      // 6️⃣ Show consolidated message
      setMessageType(errorFound ? "error" : "success");
      setAlertMessage(
        errorFound ? "Some updates failed" : "All updates successful"
      );
      setShowAlert(true);

      // 7️⃣ Reset state + callback
      resetHandler();
      afterModalClose(successData);

      // 8️⃣ Close modal
      const bootstrapModal = document.querySelector("#addCompanyModal");
      const myModal = bootstrap.Modal.getInstance(bootstrapModal);
      myModal?.hide();
    } catch (error) {
      setShowAlert(true);
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsSaving(false);
    }
  };

  // Reset all the form fields and state variables to their initial values
  const resetHandler = () => {
    setCompanyInput("");
    setCompanyOptions([]);
    setCompanyValue(null);
    setSelectedCompany(null);
    setCompanyName("");
    setErrors({});
    onModalClose();
  };

  useEffect(() => {
    if (companyInput.length > 0) {
      getCompanyList();
    }
  }, [companyInput]);

  return (
    <div
      className="modal fade"
      id="addCompanyModal"
      tabIndex="-1"
      aria-labelledby="addCompanyModal"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white px-4 py-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary icon-md">
                  apartment
                </span>
              </div>
              <div>
                <h3 className="fw-bold fs-4 text-white mb-0" id="addFollowers">
                  {t("Add Company")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Choose company to associate items with")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            {/* Professional Card Layout */}
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
              {isSaving && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white bg-opacity-75"
                  style={{ zIndex: 1050 }}
                >
                  <div
                    className="spinner-border text-primary mb-3"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="text-primary fw-semibold mb-0">
                    {t("Adding company to selected items")}, {t("please wait")}
                    ...
                  </p>
                </div>
              )}
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="selectList"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Select or Search Company to Associate")}
                    </label>
                    <Select
                      isClearable
                      placeholder={t("Search or select company by name")}
                      options={companyOptions}
                      value={companyValue}
                      onChange={(val) => companySelectionHandler(val)}
                      onInputChange={(val) => {
                        companyInputHandler(val);
                        if (errors.companyWarning) {
                          setErrors((prev) => ({
                            ...prev,
                            companyWarning: "",
                          }));
                        }
                      }}
                      styles={getCustomStyles(errors.companyWarning)}
                    />
                    {errors.companyWarning && (
                      <div className="invalid-feedback d-block">
                        * {errors.companyWarning}
                      </div>
                    )}
                  </div>
                </div>
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={() => {
                      addCompanyHandler("1");
                    }}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    <span className="material-symbols-outlined me-1">add</span>
                    {t("Add Company")}
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  {/* Uncomment and style if "Remove Followers" button is needed */}
                  {/* <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center gap-2 ms-2"
                    onClick={() => {
                      addRemoveFollowersHandler("0");
                    }}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    <span className="material-symbols-outlined me-1">remove</span>
                    {t("Remove Followers")}
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCompanyModal;
